export default {
  events: [{
      id: 'gatwick-departure',
      name: 'London Gatwick, England',
      lat: 51.5286416,
      lng: -0.1015987,
      depart: '2017-10-02',
      start: true,
      to: [{
        type: 'flight',
        departFrom: 'London, Gatwick',
        terminal: 'South Terminal',
        departureDate: '2017-10-02',
        departureTime: '09:25',
        flightNumber: 'BA2169',
        arriveAt: 'Fort Lauderdale, Miami',
        arrivalTime: '13:45',
      }, ],
    },
    {
      id: 'fort-lauderdale',
      name: 'Fort Lauderdale, Miami',
      lat: 26.0715426,
      lng: -80.2231268,
      arrive: '2017-10-02',
      to: [{
        type: 'flight',
        departFrom: 'Miami',
        terminal: 'South Terminal',
        departureDate: '2017-10-05',
        departureTime: '17:20',
        flightNumber: 'AM413',
        arriveAt: 'Mexico City',
        arrivalTime: '19:55',
      }, ],
      itinerary: [{
          date: '2017-10-02',
          descr: 'Landed in afternoon; Hurricane Irma put paid to any beach time; Cheesecake Factory',
          media: {
            video: ['media-lauderdale-lapse']
          },
        },
        {
          date: '2017-10-03',
          descr: 'Breakfast at Burlocks; Jungle Queen Boat Ride; Gator Wrestling',
          media: {
            'video': ['media-jungle-queen', 'media-gator-wrestling']
          },
        },
        {
          date: '2017-10-04',
          descr: 'Everglades Alligator Boat Trip',
          media: {
            'video': ['media-evergaldes-gators']
          },
        },
        {
          date: '2017-10-05',
          descr: 'Early morning flight to Mexico City; Footy on at the airport - England qualify for World Cup; Last minute Kane goal',
        },
      ],
    },
    {
      id: 'mexico-city',
      name: 'Mexico City',
      lat: 19.39068,
      lng: -99.2836987,
      arrive: '2017-10-05',
      to: [{
        type: 'flight',
        departFrom: 'Mexico City',
        terminal: 'Terminal 2',
        departureDate: '2017-10-08',
        departureTime: '10:20',
        flightNumber: 'AM413',
        arriveAt: 'Havana',
        arrivalTime: '14:10',
      }, ],
      itinerary: [{
          date: '2017-10-05',
          descr: 'Land that evening, make way to hotel',
        },
        {
          date: '2017-10-06',
          descr: 'Hop on Hop Off Bus Tour; Didn\'t Hop Off',
          media: {
            'video': ['media-mexico-city-bus-tour']
          },
        },
        {
          date: '2017-10-07',
          descr: 'Explore the City; Relax by the pool',
          media: {
            'video': ['media-mexico-city-culture-pool']
          },
        },
        {
          date: '2017-10-08',
          descr: 'Early set off for airport',
        },
      ],
    },
    {
      id: 'cuba',
      name: 'Havana, Cuba',
      lat: 23.0506008,
      lng: -82.4727976,
      arrive: '2017-10-08',
      to: [{
          type: 'flight',
          departFrom: 'Havana',
          terminal: 'Terminal 3',
          departureDate: '2017-10-16',
          departureTime: '17:55',
          flightNumber: 'AM413',
          arriveAt: 'San Salvador',
          arrivalTime: '18:05',
        },
        {
          type: 'flight',
          departFrom: 'San Salvador',
          terminal: '',
          departureDate: '2017-10-16',
          departureTime: '20:00',
          flightNumber: 'AM413',
          arriveAt: 'Quito',
          arrivalTime: '00:01',
        },
      ],
      itinerary: [{
          date: '2017-10-08',
          descr: 'Arrive in downtown; Check-in to shabby but not chique "Hemingway" hotel',
        },
        {
          date: '2017-10-09',
          descr: 'Tour Havana in Classic Chevvy; Decide to upgrade hotel',
          media: {
            'video': ['media-havana-road-trip']
          },
        },
        {
          date: '2017-10-10',
          descr: 'Check in to decent hotel; Explore the city; Enjoy the hotel!',
          media: {
            'video': ['media-havana-hotel-upgrade']
          },
        },
        {
          date: '2017-10-11',
          descr: 'Chill by the pool; Head to central Havana for rooftop dinner',
          media: {
            'video': ['media-pool-day-dinner']
          },
        },
        {
          date: '2017-10-12',
          descr: 'Cuban Revolution Museum; Good in theory',
          media: {
            'video': ['media-wet-revolution']
          },
        },
        {
          date: '2017-10-13',
          descr: 'Cigar Factory Tour; Bought Cigar; Smoked Cigar',
          media: {
            'video': ['media-cigar-tour']
          },
        },
        {
          date: '2017-10-14',
          descr: 'Bus to the Beach; Playas Del Este',
          media: {
            'video': ['media-playas-del-este']
          },
        },
        {
          date: '2017-10-15',
          descr: 'Pool day all day!',
          media: {
            'video': ['media-goodbye-havana']
          },
        },
        {
          date: '2017-10-16',
          descr: 'Check out of BOTH hotels',
        },
      ],
    },
    {
      id: 'quito-1',
      name: 'Quito, Ecuador',
      lat: -0.1865938,
      lng: -78.5706249,
      arrive: '2017-10-16',
      itinerary: [{
          date: '2017-10-16',
          descr: 'In the air - land in Quito tomorrow',
        },
        {
          date: '2017-10-17',
          descr: 'Check in to Hotel Plaza Sucre; Google Translate facilitated taxi tour; Cable Car; Middle Earth; Pululahua Crater',
          media: {
            'video': ['media-quito-middle-earth']
          },
        },
        {
          date: '2017-10-18',
          descr: 'Long lie in to counter act altitude sickness; Hop on Hop Off Bus Tour; Virgin of Quito Statue (earthquake protectionist)',
          media: {
            'video': ['media-quito-bus-tour']
          },
        },
        {
          date: '2017-10-19',
          descr: 'Locals bus trip back to Pululahua (aka Paul); Afternoon meet the Intrepids (well half of them); Old Town orientation walk with David',
          activities: [{
            type: 'Intrepid',
            name: 'Active Galapagos',
            link: 'http://www.intrepidtravel.com/uk/ecuador/active-galapagos-101537',
            day: 1,
          }, ],
          media: {
            'video': ['media-intrepid-quito']
          },
        },
        {
          date: '2017-10-20',
          descr: 'Early morning flight to Galapagos',
          activities: [{
            type: 'Intrepid',
            name: 'Active Galapagos',
            link: 'http://www.intrepidtravel.com/uk/ecuador/active-galapagos-101537',
            day: 2,
          }, ],
        },
      ],
      to: [{
        type: 'flight',
        departFrom: 'Quito',
        terminal: '',
        departureDate: '2017-10-20',
        departureTime: '08:30/10:30',
        flightNumber: 'AM413',
        arriveAt: 'San Cristobal Island, Galapagos',
        arrivalTime: '12:00/14:00',
      }, ],
    },
    {
      id: 'galapagos',
      name: 'Galápagos Islands, Ecuador',
      lat: -0.8666465,
      lng: -89.4509167,
      arrive: '2017-10-20',
      links: [{
        title: 'Active Galapagos',
        url: 'http://www.intrepidtravel.com/uk/ecuador/active-galapagos-101537',
      }, ],
      to: [{
        type: 'flight',
        departFrom: 'Isla Santa Cruz',
        terminal: 'via Guayaquil',
        departureDate: '2017-10-27',
        departureTime: 'TBC',
        flightNumber: '',
        arriveAt: 'Quito',
        arrivalTime: 'TBC',
      }, ],
      itinerary: [{
          date: '2017-10-20',
          descr: 'San Cristobal Island; Meet our legendary tour guide Jorge (Whore-Hay); Snorkelling in La Loberia with sea lions and sea turtles',
          activities: [{
            type: 'Intrepid',
            name: 'Active Galapagos',
            link: 'http://www.intrepidtravel.com/uk/ecuador/active-galapagos-101537',
            day: 2,
          }, ],
          media: {
            'video': ['media-galapagos-day-1']
          },
        },
        {
          date: '2017-10-21',
          descr: 'San Cristobal Island; Visit Interpretation Center; Boat to Leon Dormido; Snorkelling with turtles, sea lions & SHARKS!; Climb Frigatebird Hill',
          activities: [{
            type: 'Intrepid',
            name: 'Active Galapagos',
            link: 'http://www.intrepidtravel.com/uk/ecuador/active-galapagos-101537',
            day: 3,
          }, ],
          media: {
            'video': ['media-galapagos-day-2-part-1', 'media-galapagos-day-2-part-2']
          },
        },
        {
          date: '2017-10-22',
          descr: 'Isabela Island; Boat to Floreana Island; More snorkelling',
          activities: [{
            type: 'Intrepid',
            name: 'Active Galapagos',
            link: 'http://www.intrepidtravel.com/uk/ecuador/active-galapagos-101537',
            day: 4,
          }, ],
          media: {
            'video': ['media-galapagos-day-3']
          },
        },
        {
          date: '2017-10-23',
          descr: 'Isabela Island; Snorkelling; Giant Tortoise Breeding Center; Boat to Shark Alley',
          activities: [{
            type: 'Intrepid',
            name: 'Active Galapagos',
            link: 'http://www.intrepidtravel.com/uk/ecuador/active-galapagos-101537',
            day: 5,
          }, ],
          media: {
            'video': ['media-galapagos-day-4-part-1', 'media-galapagos-day-4-part-2']
          },
        },
        {
          date: '2017-10-24',
          descr: 'Isabela Island; Sierra Negra Volcano (5 hour hike)',
          activities: [{
            type: 'Intrepid',
            name: 'Active Galapagos',
            link: 'http://www.intrepidtravel.com/uk/ecuador/active-galapagos-101537',
            day: 6,
          }, ],
          media: {
            'video': ['media-galapagos-day-5']
          },
        },
        {
          date: '2017-10-25',
          descr: 'Santa Cruz Island; Charles Darwin Research Station',
          activities: [{
            type: 'Intrepid',
            name: 'Active Galapagos',
            link: 'http://www.intrepidtravel.com/uk/ecuador/active-galapagos-101537',
            day: 7,
          }, ],
          media: {
            'video': ['media-galapagos-day-6']
          },
        },
        {
          date: '2017-10-26',
          descr: 'Santa Cruz Island; Hike to Tortuga Bay beach; Kayaking',
          activities: [{
            type: 'Intrepid',
            name: 'Active Galapagos',
            link: 'http://www.intrepidtravel.com/uk/ecuador/active-galapagos-101537',
            day: 8,
          }, ],
          media: {
            'video': ['media-galapagos-day-7']
          },
        },
        {
          date: '2017-10-27',
          descr: 'Goodbye Galapagos; Emotional farewell with Jorge (Whore-Hay); Flight back to Quito',
          activities: [{
            type: 'Intrepid',
            name: 'Active Galapagos',
            link: 'http://www.intrepidtravel.com/uk/ecuador/active-galapagos-101537',
            day: 9,
          }, ],
        },
      ],
    },
    {
      id: 'quito-2',
      name: 'Quito, Ecuador',
      lat: -0.1865938,
      lng: -78.5706249,
      arrive: '2017-10-27',
      itinerary: [{
          date: '2017-10-27',
          descr: 'Day in Quito',
          activities: [{
            type: 'Intrepid',
            name: 'Active Galapagos',
            link: 'http://www.intrepidtravel.com/uk/ecuador/active-galapagos-101537',
            day: 9,
          }, ],
        },
        {
          date: '2017-10-28',
          descr: 'Day in Quito',
          activities: [{
            type: 'Intrepid',
            name: 'Active Galapagos',
            link: 'http://www.intrepidtravel.com/uk/ecuador/active-galapagos-101537',
            day: 10,
          }, ],
          media: {
            'video': ['media-return-to-quito']
          },
        },
        {
          date: '2017-10-29',
          descr: 'Day in Quito; Flight out early evening',
        },
      ],
      to: [{
        type: 'flight',
        departFrom: 'Quito',
        terminal: '',
        departureDate: '2017-10-29',
        departureTime: '18:29',
        flightNumber: 'AV7388',
        arriveAt: 'Lima',
        arrivalTime: '20:49',
      }, ],
    },
    {
      id: 'lima',
      name: 'Lima, Peru',
      lat: -12.0472065,
      lng: -77.0489151,
      arrive: '2017-10-29',
      itinerary: [{
          date: '2017-10-29',
          descr: 'Hotel La Castellana',
        },
        {
          date: '2017-10-30',
          descr: '2pm meet and greet; Walking tour',
          activities: [{
            type: 'Intrepid',
            name: 'Inca Trail',
            link: 'http://www.intrepidtravel.com/uk/peru/inca-trail-101582',
            day: 1,
          }, ],
          media: {
            'video': ['media-hello-lima']
          },
        },
        {
          date: '2017-10-31',
          descr: 'Flight to Cuzco',
          activities: [{
            type: 'Intrepid',
            name: 'Inca Trail',
            link: 'http://www.intrepidtravel.com/uk/peru/inca-trail-101582',
            day: 2,
          }, ],
        },
      ],
      to: [{
        type: 'flight',
        departFrom: 'Lima',
        terminal: '',
        departureDate: '2017-10-31',
        departureTime: 'TBC',
        flightNumber: '',
        arriveAt: 'Cuzco',
        arrivalTime: 'TBC',
      }, ],
    },
    {
      id: 'cuzco-inca-trail',
      name: 'Cuzco (Inca Trail), Peru',
      lat: -13.5300096,
      lng: -72.0092895,
      arrive: '2017-10-31',
      links: [{
        title: 'Inca Trail',
        url: 'http://www.intrepidtravel.com/uk/peru/inca-trail-101582',
      }, ],
      itinerary: [{
          date: '2017-10-31',
          descr: 'Cuzco; Orientation Walk; Chocolate Museum',
          activities: [{
            type: 'Intrepid',
            name: 'Inca Trail',
            link: 'http://www.intrepidtravel.com/uk/peru/inca-trail-101582',
            day: 2,
          }, ],
          media: {
            'video': ['media-hello-cuzco']
          },
        },
        {
          date: '2017-11-01',
          descr: 'Sacred Valley - Local community visit and lunch',
          activities: [{
            type: 'Intrepid',
            name: 'Inca Trail',
            link: 'http://www.intrepidtravel.com/uk/peru/inca-trail-101582',
            day: 3,
          }, ],
          media: {
            'video': ['media-sacred-valley-farm']
          },
        },
        {
          date: '2017-11-02',
          descr: 'Inca Trail; Trekking: Ollantaytambo, Huillca Raccay, Llactapata, Veronica Peak; Camping',
          activities: [{
            type: 'Intrepid',
            name: 'Inca Trail',
            link: 'http://www.intrepidtravel.com/uk/peru/inca-trail-101582',
            day: 4,
          }, ],
          media: {
            'video': ['media-inca-trail-day-1']
          },
        },
        {
          date: '2017-11-03',
          descr: 'Inca Trail; Trekking; Highest point of trail; Warmiwanusca / \'Dead Woman\'s Pass\'; Camping in Pacaymayo Valley',
          activities: [{
            type: 'Intrepid',
            name: 'Inca Trail',
            link: 'http://www.intrepidtravel.com/uk/peru/inca-trail-101582',
            day: 5,
          }, ],
          media: {
            'video': ['media-inca-trail-day-2']
          },
        },
        {
          date: '2017-11-04',
          descr: 'Inca Trail; Trekking; Runkuracay Pass; Cordillera Vilcabamba Mountain; Ruins of Sayacmarca',
          activities: [{
            type: 'Intrepid',
            name: 'Inca Trail',
            link: 'http://www.intrepidtravel.com/uk/peru/inca-trail-101582',
            day: 6,
          }, ],
          media: {
            'video': ['media-inca-trail-day-3']
          },
        },
        {
          date: '2017-11-05',
          descr: 'Inca Trail; 4:30am start; Trek to Machu Pichu ‘Lost City of the Incas’ as the sun rises (and before tourists arrive)',
          activities: [{
            type: 'Intrepid',
            name: 'Inca Trail',
            link: 'http://www.intrepidtravel.com/uk/peru/inca-trail-101582',
            day: 7,
          }, ],
          media: {
            'video': ['media-inca-trail-day-4']
          },
        },
        {
          date: '2017-11-06',
          descr: 'Cusco; Rest day',
          activities: [{
            type: 'Intrepid',
            name: 'Inca Trail',
            link: 'http://www.intrepidtravel.com/uk/peru/inca-trail-101582',
            day: 8,
          }, ],
        },
        {
          date: '2017-11-07',
          descr: 'Cusco',
        },
        {
          date: '2017-11-08',
          descr: 'Early flight to La Paz',
        },
      ],
      to: [{
        type: 'flight',
        departFrom: 'Cuzco',
        terminal: '',
        departureDate: '2017-11-08',
        departureTime: '07:50',
        flightNumber: 'UZJWEJ',
        arriveAt: 'La Paz',
        arrivalTime: '09:50',
      }, ],
    },
    {
      id: 'lapaz-1',
      name: 'La Paz, Bolivia',
      lat: -16.5207007,
      lng: -68.1615534,
      arrive: '2017-11-08',
      itinerary: [{
          date: '2017-11-08',
          descr: 'Hotel Osira',
          media: {
            blog_: ['hello-lapaz']
          },
        },
        {
          date: '2017-11-09',
          descr: '6pm meet and greet',
          media: {
            blog_: ['day-2-lapaz']
          },
          activities: [{
            type: 'Intrepid',
            name: 'Bolivian Amazon Jungle',
            link: 'http://www.intrepidtravel.com/uk/bolivia/bolivian-amazon-jungle-101542',
            day: 1,
          }, ],
        },
        {
          date: '2017-11-10',
          descr: 'Morning departure',
          activities: [{
            type: 'Intrepid',
            name: 'Bolivian Amazon Jungle',
            link: 'http://www.intrepidtravel.com/uk/bolivia/bolivian-amazon-jungle-101542',
            day: 2,
          }, ],
        },
      ],
      to: [{
          type: 'flight',
          departFrom: 'La Paz',
          terminal: '',
          departureDate: '2017-11-10',
          departureTime: '07:00',
          flightNumber: '',
          arriveAt: 'Rurrenabaque',
          arrivalTime: '07:45',
        },
        {
          type: 'boat',
          departFrom: 'Rurrenabaque',
          terminal: '',
          departureDate: '2017-11-10',
          departureTime: '09:00',
          flightNumber: '',
          arriveAt: 'Madidi',
          arrivalTime: '12:00',
        },
      ],
    },
    {
      id: 'madidi',
      name: 'Madidi National Park, Bolivia',
      lat: -14.3710403,
      lng: -68.2956107,
      arrive: '2017-11-10',
      itinerary: [{
          date: '2017-11-10',
          descr: '3 hour boat ride from Rurrenabaque to Madidi via Bala Canyon and Caquiahuara; 3 hour walk along the Wabu Trail; Jungle Lodge',
          activities: [{
            type: 'Intrepid',
            name: 'Bolivian Amazon Jungle',
            link: 'http://www.intrepidtravel.com/uk/bolivia/bolivian-amazon-jungle-101542',
            day: 2,
          }, ],
          media: {
            'video': ['day-1-madidi-jungle']
          },
        },
        {
          date: '2017-11-11',
          descr: '4 hour guided walk Mapajo Trail; Boat trip along river Tuichi; Fish for piranhas; Forest night walk',
          activities: [{
            type: 'Intrepid',
            name: 'Bolivian Amazon Jungle',
            link: 'http://www.intrepidtravel.com/uk/bolivia/bolivian-amazon-jungle-101542',
            day: 3,
          }, ],
          media: {
            'video': ['day-2-madidi-jungle']
          },
        },
        {
          date: '2017-11-12',
          descr: '4 hour guided walk Mapajo and Pavacullpana Trails; Sample local dish the \'Dunucuabi\'',
          activities: [{
            type: 'Intrepid',
            name: 'Bolivian Amazon Jungle',
            link: 'http://www.intrepidtravel.com/uk/bolivia/bolivian-amazon-jungle-101542',
            day: 4,
          }, ],
          media: {
            'video': ['day-3-madidi-jungle']
          },
        },
        {
          date: '2017-11-13',
          descr: 'Morning Hike; Boat trip along the River Tuichi; Flight back to La Paz',
          activities: [{
            type: 'Intrepid',
            name: 'Bolivian Amazon Jungle',
            link: 'http://www.intrepidtravel.com/uk/bolivia/bolivian-amazon-jungle-101542',
            day: 5,
          }, ],
          media: {
            'video': ['day-4-madidi-jungle']
          },
        },
      ],
      to: [{
          type: 'boat',
          departFrom: 'Madidi',
          terminal: '',
          departureDate: '2017-11-13',
          departureTime: '15:00',
          flightNumber: '',
          arriveAt: 'Rurrenabaque',
          arrivalTime: '17:00',
        },
        {
          type: 'flight',
          departFrom: 'Rurrenabaque',
          terminal: '',
          departureDate: '2017-11-13',
          departureTime: '21:00',
          flightNumber: '',
          arriveAt: 'La Paz',
          arrivalTime: '21:45',
        },
      ],
    },
    {
      id: 'lapaz-2',
      name: 'La Paz, Bolivia',
      lat: -16.5207007,
      lng: -68.1615534,
      arrive: '2017-11-13',
      itinerary: [{
          date: '2017-11-13',
          descr: 'Arrive late evening',
          activities: [{
            type: 'Intrepid',
            name: 'Bolivian Amazon Jungle',
            link: 'http://www.intrepidtravel.com/uk/bolivia/bolivian-amazon-jungle-101542',
            day: 5,
          }, ],
        },
        {
          date: '2017-11-14',
          descr: 'Hotel Osira',
        },
        {
          date: '2017-11-15',
          descr: 'Hotel Osira',
        },
        {
          date: '2017-11-16',
          descr: 'Hotel Osira; 6pm meet and greet',
          activities: [{
            type: 'Intrepid',
            name: 'Bolivian Salt Flats',
            link: 'http://www.intrepidtravel.com/uk/bolivia/bolivian-salt-flats-andean-desert-102226',
            day: 1,
          }, ],
        },
        {
          date: '2017-11-17',
          descr: 'Early fight to Uyuni',
          activities: [{
            type: 'Intrepid',
            name: 'Bolivian Salt Flats',
            link: 'http://www.intrepidtravel.com/uk/bolivia/bolivian-salt-flats-andean-desert-102226',
            day: 2,
          }, ],
        },
      ],
      to: [{
        type: 'flight',
        departFrom: 'La Paz',
        terminal: '',
        departureDate: '2017-11-17',
        departureTime: '08:00*',
        flightNumber: '',
        arriveAt: 'Uyuni',
        arrivalTime: '09:00*',
      }, ],
    },
    {
      id: 'uyuni',
      name: 'Uyuni, Bolivia',
      lat: -20.4607055,
      lng: -66.8623216,
      arrive: '2017-11-17',
      itinerary: [{
          date: '2017-11-17',
          descr: '4x4 tour of Salar de Uyuni; visit  Isla Inca Wasi; Uyuni Salt Flats tour',
          activities: [{
            type: 'Intrepid',
            name: 'Bolivian Salt Flats',
            link: 'http://www.intrepidtravel.com/uk/bolivia/bolivian-salt-flats-andean-desert-102226',
            day: 2,
          }, ],
        },
        {
          date: '2017-11-18',
          descr: 'Andean Dessert; Salt flats - Altiplano tour including Laguna Colorada and Laguna Verde',
          activities: [{
            type: 'Intrepid',
            name: 'Bolivian Salt Flats',
            link: 'http://www.intrepidtravel.com/uk/bolivia/bolivian-salt-flats-andean-desert-102226',
            day: 3,
          }, ],
        },
        {
          date: '2017-11-19',
          descr: 'Natural hot springs; Uyuni old town',
          activities: [{
            type: 'Intrepid',
            name: 'Bolivian Salt Flats',
            link: 'http://www.intrepidtravel.com/uk/bolivia/bolivian-salt-flats-andean-desert-102226',
            day: 4,
          }, ],
        },
        {
          date: '2017-11-20',
          descr: 'Morning flight back to La Paz',
          activities: [{
            type: 'Intrepid',
            name: 'Bolivian Salt Flats',
            link: 'http://www.intrepidtravel.com/uk/bolivia/bolivian-salt-flats-andean-desert-102226',
            day: 5,
          }, ],
        },
      ],
      to: [{
        type: 'flight',
        departFrom: 'Uyuni',
        terminal: '',
        departureDate: '2017-11-20',
        departureTime: '08:00*',
        flightNumber: '',
        arriveAt: 'La Paz',
        arrivalTime: '09:00*',
      }, ],
    },
    {
      id: 'lapaz-3',
      name: 'La Paz, Bolivia',
      lat: -16.5207007,
      lng: -68.1615534,
      arrive: '2017-11-20',
      itinerary: [{
          date: '2017-11-20',
          descr: 'Rest Day',
          activities: [{
            type: 'Intrepid',
            name: 'Bolivian Salt Flats',
            link: 'http://www.intrepidtravel.com/uk/bolivia/bolivian-salt-flats-andean-desert-102226',
            day: 5,
          }, ],
        },
        {
          date: '2017-11-21',
          descr: 'Flight to Santiago',
        },
      ],
      to: [{
        type: 'flight',
        departFrom: 'La Paz',
        terminal: '',
        departureDate: '2017-11-20',
        departureTime: '03:00',
        flightNumber: 'LA893',
        arriveAt: 'Santiago',
        arrivalTime: '07:00',
      }, ],
    },
    {
      id: 'santiago',
      name: 'Santiago, Chile',
      lat: -33.4727092,
      lng: -70.769916,
      arrive: '2017-11-21',
      itinerary: [{
          date: '2017-11-21',
          descr: 'Sommelier Express Hotel',
        },
        {
          date: '2017-11-22',
          descr: 'Sommelier Express Hotel',
        },
        {
          date: '2017-11-23',
          descr: 'Sommelier Express Hotel',
        },
        {
          date: '2017-11-24',
          descr: 'Sommelier Express Hotel',
        },
        {
          date: '2017-11-25',
          descr: 'Sommelier Express Hotel',
        },
        {
          date: '2017-11-26',
          descr: 'Evening Meet and Greet',
          activities: [{
            type: 'Intrepid',
            name: 'Patagonia Trekking',
            link: 'http://www.intrepidtravel.com/uk/chile/patagonia-trekking-101503',
            day: 1,
          }, ],
        },
        {
          date: '2017-11-27',
          descr: 'Travel Day',
          activities: [{
            type: 'Intrepid',
            name: 'Patagonia Trekking',
            link: 'http://www.intrepidtravel.com/uk/chile/patagonia-trekking-101503',
            day: 2,
          }, ],
        },
      ],
      to: [{
          type: 'flight',
          departFrom: 'Santiago',
          terminal: '',
          departureDate: '2017-11-27',
          departureTime: '09:00*',
          flightNumber: '',
          arriveAt: 'Punta Arenas',
          arrivalTime: '13:00*',
        },
        {
          type: 'bus',
          departFrom: 'Punta Arenas',
          terminal: '',
          departureDate: '2017-11-27',
          departureTime: '15:00*',
          flightNumber: '',
          arriveAt: 'Puerto Natales',
          arrivalTime: '18:00*',
        },
      ],
    },
    {
      id: 'patagonia',
      name: 'Torres del Paine National Park, Patagonia',
      lat: -50.9710789,
      lng: -73.3438208,
      arrive: '2017-11-27',
      itinerary: [{
          date: '2017-11-27',
          descr: 'Arrive late; Prepare for 4 days of trekking',
          activities: [{
            type: 'Intrepid',
            name: 'Patagonia Trekking',
            link: 'http://www.intrepidtravel.com/uk/chile/patagonia-trekking-101503',
            day: 2,
          }, ],
        },
        {
          date: '2017-11-28',
          descr: 'Trek to Grey Glacier; Camping',
          activities: [{
            type: 'Intrepid',
            name: 'Patagonia Trekking',
            link: 'http://www.intrepidtravel.com/uk/chile/patagonia-trekking-101503',
            day: 3,
          }, ],
        },
        {
          date: '2017-11-29',
          descr: 'Trek to French Valley; Camping',
          activities: [{
            type: 'Intrepid',
            name: 'Patagonia Trekking',
            link: 'http://www.intrepidtravel.com/uk/chile/patagonia-trekking-101503',
            day: 4,
          }, ],
        },
        {
          date: '2017-11-30',
          descr: 'Cross Peohe Lake by catamaran; Bus to Laguna Amarga; Hike; Camping',
          activities: [{
            type: 'Intrepid',
            name: 'Patagonia Trekking',
            link: 'http://www.intrepidtravel.com/uk/chile/patagonia-trekking-101503',
            day: 5,
          }, ],
        },
        {
          date: '2017-12-01',
          descr: '9 hour trek to Mirador de las Torres; Camping',
          activities: [{
            type: 'Intrepid',
            name: 'Patagonia Trekking',
            link: 'http://www.intrepidtravel.com/uk/chile/patagonia-trekking-101503',
            day: 6,
          }, ],
        },
        {
          date: '2017-12-02',
          descr: 'Travel Day',
          activities: [{
            type: 'Intrepid',
            name: 'Patagonia Trekking',
            link: 'http://www.intrepidtravel.com/uk/chile/patagonia-trekking-101503',
            day: 7,
          }, ],
        },
      ],
      to: [{
        type: 'bus',
        departFrom: 'Torres del Paine',
        terminal: '',
        departureDate: '2017-12-02',
        departureTime: '08:00*',
        flightNumber: '',
        arriveAt: 'El Calafate',
        arrivalTime: '15:00*',
      }, ],
    },
    {
      id: 'el-calafate',
      name: 'El Calafate, Argentina',
      lat: -50.3295053,
      lng: -72.3327648,
      arrive: '2017-12-02',
      itinerary: [{
          date: '2017-12-02',
          descr: 'Arrive late',
          activities: [{
            type: 'Intrepid',
            name: 'Patagonia Trekking',
            link: 'http://www.intrepidtravel.com/uk/chile/patagonia-trekking-101503',
            day: 7,
          }, ],
        },
        {
          date: '2017-12-03',
          descr: 'Perito Moreno Glacier; Optional trek',
          activities: [{
            type: 'Intrepid',
            name: 'Patagonia Trekking',
            link: 'http://www.intrepidtravel.com/uk/chile/patagonia-trekking-101503',
            day: 8,
          }, ],
        },
        {
          date: '2017-12-04',
          descr: 'Flight to Buenos Aires; Orientation walk',
          activities: [{
            type: 'Intrepid',
            name: 'Patagonia Trekking',
            link: 'http://www.intrepidtravel.com/uk/chile/patagonia-trekking-101503',
            day: 9,
          }, ],
        },
      ],
      to: [{
        type: 'flight',
        departFrom: 'El Calafate',
        terminal: '',
        departureDate: '2017-12-04',
        departureTime: '08:00*',
        flightNumber: '',
        arriveAt: 'Buenos Aires',
        arrivalTime: '15:00*',
      }, ],
    },
    {
      id: 'buenos-aires',
      name: 'Buenos Aires, Argentina',
      lat: -34.6157142,
      lng: -58.5033604,
      arrive: '2017-12-04',
      itinerary: [{
          date: '2017-12-04',
          descr: 'Flight to Buenos Aires; Orientation walk',
          activities: [{
            type: 'Intrepid',
            name: 'Patagonia Trekking',
            link: 'http://www.intrepidtravel.com/uk/chile/patagonia-trekking-101503',
            day: 9,
          }, ],
        },
        {
          date: '2017-12-05',
          descr: 'TBC',
          activities: [{
            type: 'Intrepid',
            name: 'Patagonia Trekking',
            link: 'http://www.intrepidtravel.com/uk/chile/patagonia-trekking-101503',
            day: 10,
          }, ],
        },
        {
          date: '2017-12-06',
          descr: 'TBC',
        },
        {
          date: '2017-12-07',
          descr: 'TBC',
        },
        {
          date: '2017-12-08',
          descr: 'TBC',
        },
        {
          date: '2017-12-09',
          descr: '6pm meet and greet',
          activities: [{
            type: 'Intrepid',
            name: 'Best of Argentina & Brazil',
            link: 'http://www.intrepidtravel.com/uk/argentina/best-argentina-brazil-101499',
            day: 1,
          }, ],
        },
        {
          date: '2017-12-10',
          descr: 'Full-day guided tour; Football match Racing Club v Gimnasia',
          activities: [{
            type: 'Intrepid',
            name: 'Best of Argentina & Brazil',
            link: 'http://www.intrepidtravel.com/uk/argentina/best-argentina-brazil-101499',
            day: 2,
          }, ],
        },
        {
          date: '2017-12-11',
          descr: 'Fly to Puerto Iguazu',
          activities: [{
            type: 'Intrepid',
            name: 'Best of Argentina & Brazil',
            link: 'http://www.intrepidtravel.com/uk/argentina/best-argentina-brazil-101499',
            day: 3,
          }, ],
        },
      ],
      to: [{
        type: 'flight',
        departFrom: 'Buenos Aires',
        terminal: '',
        departureDate: '2017-12-11',
        departureTime: '08:00*',
        flightNumber: '',
        arriveAt: 'Puerto Iguazu',
        arrivalTime: '10:00*',
      }, ],
    },
    {
      id: 'iguaza',
      name: 'Iguazu Falls, Argentina & Brazil',
      lat: -25.695259,
      lng: -54.4388549,
      arrive: '2017-12-11',
      itinerary: [{
          date: '2017-12-11',
          descr: 'Early morning flight; Tour of Brazilian side of the falls',
          activities: [{
            type: 'Intrepid',
            name: 'Best of Argentina & Brazil',
            link: 'http://www.intrepidtravel.com/uk/argentina/best-argentina-brazil-101499',
            day: 3,
          }, ],
        },
        {
          date: '2017-12-12',
          descr: 'Tour of Argentinian side of the falls',
          activities: [{
            type: 'Intrepid',
            name: 'Best of Argentina & Brazil',
            link: 'http://www.intrepidtravel.com/uk/argentina/best-argentina-brazil-101499',
            day: 4,
          }, ],
        },
        {
          date: '2017-12-13',
          descr: 'Early flight to Rio',
          activities: [{
            type: 'Intrepid',
            name: 'Best of Argentina & Brazil',
            link: 'http://www.intrepidtravel.com/uk/argentina/best-argentina-brazil-101499',
            day: 5,
          }, ],
        },
      ],
      to: [{
        type: 'flight',
        departFrom: 'Foz do Iguacu',
        terminal: '',
        departureDate: '2017-12-13',
        departureTime: '08:00*',
        flightNumber: '',
        arriveAt: 'Rio De Janeiro',
        arrivalTime: '10:00*',
      }, ],
    },
    {
      id: 'rio-1',
      name: 'Rio de Janeiro, Brazil',
      lat: -22.0622487,
      lng: -44.0448167,
      arrive: '2017-12-13',
      itinerary: [{
          date: '2017-12-13',
          descr: 'Rest Day',
          activities: [{
            type: 'Intrepid',
            name: 'Best of Argentina & Brazil',
            link: 'http://www.intrepidtravel.com/uk/argentina/best-argentina-brazil-101499',
            day: 5,
          }, ],
        },
        {
          date: '2017-12-14',
          descr: 'Guided tour including Santa Teresa and Selaron Steps',
          activities: [{
            type: 'Intrepid',
            name: 'Best of Argentina & Brazil',
            link: 'http://www.intrepidtravel.com/uk/argentina/best-argentina-brazil-101499',
            day: 6,
          }, ],
        },
        {
          date: '2017-12-15',
          descr: 'Morning check-out',
          activities: [{
            type: 'Intrepid',
            name: 'Best of Argentina & Brazil',
            link: 'http://www.intrepidtravel.com/uk/argentina/best-argentina-brazil-101499',
            day: 7,
          }, ],
        },
      ],
      to: [{
        type: 'bus',
        departFrom: 'Rio De Janeiro',
        terminal: '',
        departureDate: '2017-12-15',
        departureTime: '09:00',
        flightNumber: '',
        arriveAt: 'Paraty',
        arrivalTime: '13:00',
      }, ],
    },
    {
      id: 'paraty',
      name: 'Paraty, Brazil',
      lat: -23.2141663,
      lng: -44.7425174,
      arrive: '2017-12-15',
      to: [{
          type: 'bus',
          departFrom: 'Paraty',
          terminal: '',
          departureDate: '2017-12-20',
          departureTime: '09:00*',
          flightNumber: 'easy transfer brazil',
          arriveAt: 'Concepção de Jacarei',
          arrivalTime: '11:00*',
        },
        {
          type: 'boat',
          departFrom: 'Concepção de Jacarei',
          terminal: '',
          departureDate: '2017-12-15',
          departureTime: '12:00*',
          flightNumber: 'easy transfer brazil',
          arriveAt: 'Vila do Abraão',
          arrivalTime: '14:00*',
        },
      ],
    },
    {
      id: 'ilhla-grande',
      name: 'Ihla Grande, Brazil',
      lat: -23.1552516,
      lng: -44.3751412,
      arrive: '2017-12-21',
      to: [{
          type: 'boat',
          departFrom: 'Vila do Abraão',
          terminal: '',
          departureDate: '2017-12-29',
          departureTime: '09:00*',
          flightNumber: 'easy transfer brazil',
          arriveAt: 'Concepção de Jacarei',
          arrivalTime: '11:00*',
        },
        {
          type: 'bus',
          departFrom: 'Concepção de Jacarei',
          terminal: '',
          departureDate: '2017-12-29',
          departureTime: '12:00*',
          flightNumber: 'easy transfer brazil',
          arriveAt: 'Rio de Janeiro',
          arrivalTime: '13:00*',
        },
      ],
    },
    {
      id: 'rio-2',
      name: 'Rio de Janeiro, Brazil',
      lat: -22.0622487,
      lng: -44.0448167,
      arrive: '2017-12-29',
      itinerary: [{
          date: '2017-12-29',
          descr: 'TBC',
        },
        {
          date: '2017-12-30',
          descr: 'Hotel 55 Rio',
        },
        {
          date: '2017-12-31',
          descr: 'New Years Eve; Hotel 55 Rio',
        },
        {
          date: '2018-01-01',
          descr: 'New Years Day; Hotel 55 Rio',
        },
        {
          date: '2018-01-02',
          descr: 'Hotel 55 Rio',
        },
        {
          date: '2018-01-03',
          descr: 'Fly home',
        },
      ],
      to: [{
        type: 'flight',
        departFrom: 'Rio De Janeiro',
        terminal: '',
        departureDate: '2018-01-03',
        departureTime: '23:00',
        flightNumber: '',
        arriveAt: 'London Gatwick',
        arrivalTime: '12:10',
      }, ],
    },
    {
      id: 'gatwick-return',
      name: 'London Gatwick',
      lat: 51.5286416,
      lng: -0.1015987,
      arrive: '2018-01-03',
      end: true,
    },
  ],
  media: {
    'media-lauderdale-lapse': {
      title: 'Lauderdal Lapse',
      type: 'video',
      origin: 'url',
      value: {
        filePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F003%20-%20Fort%20Lauderdale%20Lapse.mp4?alt=media&token=9f56a451-c1a1-45ed-ad62-b460d25fa98a',
        lowResFilePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F003%20-%20Fort%20Lauderdale%20Lapse_lowres.mov?alt=media&token=716a414d-2c26-450e-9113-87681853dba8',
      }
    },
    "media-jungle-queen": {
      title: 'Jungle Queen',
      type: 'video',
      origin: 'url',
      value: {
        filePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F004%20-%20Jungle%20Queen.mp4?alt=media&token=e15590e3-9872-4838-b965-3a95dc6bfe29',
        lowResFilePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F004%20-%20Jungle%20Queen_lowres.mov?alt=media&token=f2802f55-1132-4116-8365-74fc73f96854',
      }
    },
    "media-gator-wrestling": {
      title: 'Gator Wrestling',
      type: 'video',
      origin: 'url',
      value: {
        filePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F001%20-%20Alligator%20Wrestling.mp4?alt=media&token=98b1434e-57a1-47d4-8286-d237b4b94e81',
        lowResFilePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F001%20-%20Alligator%20Wrestling_lowres.mov?alt=media&token=a1d83777-b618-4a0e-8320-d7260d47cff4',
      }
    },
    "media-evergaldes-gators": {
      title: 'Everglades Gators',
      type: 'video',
      origin: 'url',
      value: {
        filePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F002%20-%20Everglades%20Gators.mp4?alt=media&token=fc5b7289-d116-474e-922c-52e4fd2e1d61',
        lowResFilePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F002%20-%20Everglades%20Gators_lowres.mov?alt=media&token=0af036af-39cd-4d19-b9b2-b2d20ff5c52a',
      }
    },
    "media-mexico-city-bus-tour": {
      title: 'Mexico City Bus Tour',
      type: 'video',
      origin: 'url',
      value: {
        filePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F005%20-%20Mexico%20Bus%20Tour.mp4?alt=media&token=e2976588-7d66-40f3-8f28-a8c14be48b9d',
        lowResFilePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F005%20-%20Mexico%20Bus%20Tour_lowres.mov?alt=media&token=fef7fad8-1edf-4244-80ab-4009eb26050c',
      }
    },
    "media-mexico-city-culture-pool": {
      title: 'Mexico city Culture Pool',
      type: 'video',
      origin: 'url',
      value: {
        filePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F006%20-%20Mexico%20City%20Culture%20Pool.mp4?alt=media&token=7d632be1-08c4-4e1b-9ab7-67c82e810516',
        lowResFilePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F006%20-%20Mexico%20City%20Culture%20Pool_lowres.mov?alt=media&token=a4957c1f-1ae0-4c84-a625-2d95fcfaf735',
      }
    },
    "media-havana-road-trip": {
      title: 'Havana Road Trip',
      type: 'video',
      origin: 'url',
      value: {
        filePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F007%20-%20Havana%20Road%20Trip.mp4?alt=media&token=ed36da29-bd3f-4b40-8159-da3671d5ebff',
        lowResFilePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F007%20-%20Havana%20Road%20Trip_lowres.mov?alt=media&token=ac2caf8f-7052-45a9-a122-59ff9b66fc22',
      }
    },
    "media-havana-hotel-upgrade": {
      title: 'Havana Hotel Upgrade',
      type: 'video',
      origin: 'url',
      value: {
        filePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F008%20-%20Hotel%20Upgrade.mp4?alt=media&token=b56a8737-7846-4518-a592-0e4cb0b404aa',
        lowResFilePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F008%20-%20Hotel%20Upgrade_lowres.mov?alt=media&token=71fcd87c-bc9d-4411-b2ad-0218210a919c',
      }
    },
    "media-pool-day-dinner": {
      title: 'Pool Day & Dinner',
      type: 'video',
      origin: 'url',
      value: {
        filePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F009%20-%20Cuba%20Pool.mp4?alt=media&token=2fa64178-0d29-4f92-aa6d-a09b5d99265b',
        lowResFilePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F009%20-%20Cuba%20Pool_lowres.mov?alt=media&token=b90bd6d8-043f-47a0-baea-1349d8082610',
      }
    },
    "media-wet-revolution": {
      title: 'Wet Revolution',
      type: 'video',
      origin: 'url',
      value: {
        filePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F010%20-%20Wet%20Revolution.mp4?alt=media&token=6352bc21-a2b2-412e-b91a-2cc51516b7d3',
        lowResFilePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F010%20-%20Wet%20Revolution_lowres.mov?alt=media&token=3859ebd9-a256-4cc2-a2f9-41c287c7b33f',
      }
    },
    "media-cigar-tour": {
      title: 'Cigar Tour',
      type: 'video',
      origin: 'url',
      value: {
        filePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F011%20-%20Cigar%20Tour.mp4?alt=media&token=2dc44cb5-0ce8-49b5-a876-7a73c6ea1c94',
        lowResFilePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F011%20-%20Cigar%20Tour_lowres.mov?alt=media&token=bcc62feb-0e0f-4895-8497-5b73670ec70e',
      }
    },
    "media-playas-del-este": {
      title: 'Playa Del Este',
      type: 'video',
      origin: 'url',
      value: {
        filePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F012%20-%20Playas%20Del%20Este.mp4?alt=media&token=024f78e7-093c-4989-a39a-7a01b8b45708',
        lowResFilePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F012%20-%20Playas%20Del%20Este_lowres.mov?alt=media&token=d5c7d46b-e83b-435c-9929-06a6ba8e0bf7',
      }
    },
    "media-goodbye-havana": {
      title: 'Goodbye Havana',
      type: 'video',
      origin: 'url',
      value: {
        filePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F013%20-%20Goodbye%20Derek-Havana.mp4?alt=media&token=f683af2b-78d5-401e-b922-e0f529e2f008',
        lowResFilePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F013%20-%20Goodbye%20Derek-Havana_lowres.mov?alt=media&token=db58313b-aa37-4656-819c-01de02c94db9',
      }
    },
    "media-quito-middle-earth": {
      title: 'Quito Middle Earth',
      type: 'video',
      origin: 'url',
      value: {
        filePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F014%20-%20Quito%20Middle%20Earth.mp4?alt=media&token=ec60b15b-b385-4624-bea6-ee3e06b6f0c0',
        lowResFilePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F014%20-%20Quito%20Middle%20Earth_lowres.mov?alt=media&token=284a0576-e75b-4af8-a7f1-74925a53c934',
      }
    },
    "media-quito-bus-tour": {
      title: 'Quito Bus Tour',
      type: 'video',
      origin: 'url',
      value: {
        filePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F015%20-%20Quito%20Bus%20Tour.mp4?alt=media&token=3d199609-11c4-4ab2-a5a1-7ae895f73a9e',
        lowResFilePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F015%20-%20Quito%20Bus%20Tour_lowres.mov?alt=media&token=fa9794c2-1435-406b-93fb-f1ad409de8e6',
      }
    },
    "media-intrepid-quito": {
      title: 'Intrepid Quito',
      type: 'video',
      origin: 'url',
      value: {
        filePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F016%20-%20Intrepid%20Quito.mp4?alt=media&token=fb03fb69-3274-46e4-a331-460f6ac65ab3',
        lowResFilePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F016%20-%20Intrepid%20Quito_lowres.mov?alt=media&token=192e6a8b-3b91-446a-b2e6-9bbc5d136b4f',
      }
    },
    "media-galapagos-day-1": {
      title: 'Galapagos Day 1',
      type: 'video',
      origin: 'url',
      value: {
        filePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F017%20-%20Galapagos%20Day%201.mp4?alt=media&token=0a2ef1f0-9b0f-40d9-be2a-9c2536882c15',
        lowResFilePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F017%20-%20Galapigos%20Day%201_lowres.mov?alt=media&token=831f318e-531f-4c12-8308-3c798fe08431',
      }
    },
    "media-galapagos-day-2-part-1": {
      title: 'Galapagos Day 2 - Part 1',
      type: 'video',
      origin: 'url',
      value: {
        filePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F018%20-%20Galapagos%20Day%202%20Part%201.mp4?alt=media&token=94440ed3-3cbf-4957-8d27-102b2ad729e9',
        lowResFilePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F018%20-%20Galapagos%20Day%202%20Part%201_lowres.mov?alt=media&token=1fc9fe5b-02a0-4b99-9905-5c6edc2ab90d',
      }
    },
    "media-galapagos-day-2-part-2": {
      title: 'Galapagos Day 2 - Part 2',
      type: 'video',
      origin: 'url',
      value: {
        filePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F019%20-%20Galapagos%20Day%202%20Part%202.mp4?alt=media&token=880a3989-9ffa-4abb-866f-8032679206f7',
        lowResFilePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F019%20-%20Galapagos%20Day%202%20Part%202_lowres.mov?alt=media&token=70a06157-1dd4-4fcd-a0a8-f92b0a05da87',
      }
    },
    "media-galapagos-day-3": {
      title: 'Galapagos Day 3',
      type: 'video',
      origin: 'url',
      value: {
        filePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F020%20-%20Galapagos%20Day%203.mp4?alt=media&token=6eb00eed-781b-4c96-ae79-ccae0c67fcdf',
        lowResFilePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F020%20-%20Galapagos%20Day%203_lowres.mov?alt=media&token=65fd4f9d-20db-43cf-900b-69fcb717af97',
      }
    },
    "media-galapagos-day-4-part-1": {
      title: 'Galapagos Day 4 Part 1',
      type: 'video',
      origin: 'url',
      value: {
        filePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F021%20-%20Galapagos%20Day%204%20Part%201.mp4?alt=media&token=9c4c6b62-7608-4108-9b15-72add87617fa',
        lowResFilePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F021%20-%20Galapagos%20Day%204%20Part%201_lowres.mov?alt=media&token=83ec550c-a24d-4133-9f10-9be8df486ccb',
      }
    },
    "media-galapagos-day-4-part-2": {
      title: 'Galapagos Day 4 Part 2',
      type: 'video',
      origin: 'url',
      value: {
        filePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F022%20-%20Galapagos%20Day%204%20Part%202.mp4?alt=media&token=40b0f91a-9379-4e4c-ae80-65d9bdfc231c',
        lowResFilePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F022%20-%20Galapagos%20Day%204%20Part%202_lowres.mov?alt=media&token=7860c404-892a-499f-a0fe-04473f737594',
      }
    },
    "media-galapagos-day-5": {
      title: 'Galapagos Day 5',
      type: 'video',
      origin: 'url',
      value: {
        filePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F023%20-%20Galapagos%20Day%205.mp4?alt=media&token=318eba58-1e7e-4b8f-804b-96dea71d5f0e',
        lowResFilePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F023%20-%20Galapagos%20Day%205_lowres.mov?alt=media&token=0311aa36-f8dc-4774-ba6e-109cefee4209',
      }
    },
    "media-galapagos-day-6": {
      title: 'Galapagos Day 6',
      type: 'video',
      origin: 'url',
      value: {
        filePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F024%20-%20Galapagos%20Day%206.mp4?alt=media&token=ef3c066d-90e1-48eb-b0cb-ebe731f2c42c',
        lowResFilePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F024%20-%20Galapagos%20Day%206_lowres.mov?alt=media&token=e06f4aa6-3427-4031-a053-c80311cbdaae',
      }
    },
    "media-galapagos-day-7": {
      title: 'Galapagos Day 7',
      type: 'video',
      origin: 'url',
      value: {
        filePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F025%20-%20Galapagos%20Day%207.mp4?alt=media&token=2859e0a1-09b9-468d-b5d0-f366b546a80d',
        lowResFilePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F025%20-%20Galapagos%20Day%207.mp4?alt=media&token=2859e0a1-09b9-468d-b5d0-f366b546a80d',
      }
    },
    "media-return-to-quito": {
      title: 'Return To Quito',
      type: 'video',
      origin: 'url',
      value: {
        filePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F026%20-%20Return%20to%20Quito.mp4?alt=media&token=65a98b90-9e81-40a0-b8b7-41567f1a6647',
        lowResFilePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F026%20-%20Return%20to%20Quito_lowres.mov?alt=media&token=3a55a7a3-2d6d-482f-b303-0059e570c954',
      }
    },
    "media-hello-lima": {
      title: 'Hello Lima',
      type: 'video',
      origin: 'url',
      value: {
        filePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F027%20-%20Hello%20Lima.mp4?alt=media&token=59a6eed0-666b-4c6a-a7d8-950554d2b6e9',
        lowResFilePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F027%20-%20Hello%20Lima_lowres.mov?alt=media&token=d26d51c6-aff2-40f7-a1d2-e5d60e591c4a',
      }
    },
    "media-hello-cuzco": {
      title: 'Hello Cuzco',
      type: 'video',
      origin: 'url',
      value: {
        filePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F028%20-%20Hello%20Cuzco.mp4?alt=media&token=7c50b93a-b25b-48ee-a161-036d339f74d5',
        lowResFilePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F028%20-%20Hello%20Cuzco_lowres.mov?alt=media&token=f5a77b52-35b7-416e-8ff2-29ecc5ff7c22',
      }
    },
    "media-sacred-valley-farm": {
      title: 'Sacred Valley Farm',
      type: 'video',
      origin: 'url',
      value: {
        filePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F029%20-%20Sacred%20Valley%20Farm.mp4?alt=media&token=e39090f4-3a1f-4227-8e7e-db89863322b4',
        lowResFilePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F029%20-%20Sacred%20Valley%20Farm_lowres.mov?alt=media&token=68fa2068-e505-4052-a913-7c6848a163b2',
      }
    },
    "media-inca-trail-day-1": {
      title: 'Inca Trail Day 1',
      type: 'video',
      origin: 'url',
      value: {
        filePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F030%20-%20Inca%20Trail%20Day%201.mp4?alt=media&token=6fdd3d2c-9a16-4a29-b625-dd5acb090880',
        lowResFilePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F030%20-%20Inca%20Trail%20Day%201_lowres.mov?alt=media&token=49f89bdf-cd9e-4def-a51e-a90f3fdeab43',
      }
    },
    "media-inca-trail-day-2": {
      title: 'Inca Trail Day 2',
      type: 'video',
      origin: 'url',
      value: {
        filePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F031%20-%20Inca%20Trail%20Day%202.mp4?alt=media&token=c4681ebf-3b51-4422-880c-f2dbad4ae845',
        lowResFilePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F031%20-%20Inca%20Trail%20Day%202_lowres.mov?alt=media&token=c5f68ffb-0f38-4d90-95d4-6414ec333a82',
      }
    },
    "media-inca-trail-day-3": {
      title: 'Inca Trail Day 3',
      type: 'video',
      origin: 'url',
      value: {
        filePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F032%20-%20Inca%20Trail%20Day%203.mp4?alt=media&token=fa8f45b7-6b89-4562-a5fe-8e4b51e1538d',
        lowResFilePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F032%20-%20Inca%20Trail%20Day%203_lowres.mov?alt=media&token=216e3085-aef4-4a48-9469-f2dfdfe02d52',
      }
    },
    "media-inca-trail-day-4": {
      title: 'Inca Trail Day 4 Machu Picchu',
      type: 'video',
      origin: 'url',
      value: {
        filePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F033%20-%20Inca%20Trail%20Day%204%20Machu%20Picchu.mp4?alt=media&token=f2ab732e-21e3-42dc-af93-2823655f4662',
        lowResFilePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F033%20-%20Inca%20Trail%20Day%204%20Machu%20Picchu_lowres.mov?alt=media&token=b6ac8d56-a7d2-428f-a0bc-afb98fd9cfd1',
      }
    },
    "hello-lapaz": {
      title: 'Hello Lapaz',
      type: 'blog',
      value: {
        contentType: 'text',
        content: 'Some blog content as plain text',
      }
    },
    "day-2-lapaz": {
      title: 'Day 2 Lapaz',
      type: 'blog',
      value: {
        contentType: 'text',
        content: 'Some MORE blog content as plain text',
      }
    },
    "day-1-madidi-jungle": {
      title: 'Day 1 Madidi Jungle',
      type: 'video',
      origin: 'url',
      value: {
        filePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F034%20-%20Madidi%20Jungle%20Day%201.mp4?alt=media&token=abbd2287-4e52-4437-baaf-08fea42b6867',
        lowResFilePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F034%20-%20Madidi%20Jungle%20Day%201_lowres.mov?alt=media&token=999d30c9-8bb9-4d11-9f31-cac7114fe387',
      }
    },
    "day-2-madidi-jungle": {
      title: 'Day 2 Madidi Jungle',
      type: 'video',
      origin: 'url',
      value: {
        filePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F035%20-%20Madidi%20Jungle%20Day%202.mp4?alt=media&token=8d83335a-eb37-46f1-ae1b-a9999689b219',
        lowResFilePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F035%20-%20Madidi%20Jungle%20Day%202_lowres.mov?alt=media&token=1e085555-8097-44b1-80ab-7cd2ab133004',
      }
    },
    "day-3-madidi-jungle": {
      title: 'Day 3 Madidi Jungle',
      type: 'video',
      origin: 'url',
      value: {
        filePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F036%20-%20Madidi%20Jungle%20Day%203.mp4?alt=media&token=5c8c0d6c-d9a8-42f2-b2fd-e0f5dce4dd29',
        lowResFilePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F036%20-%20Madidi%20Jungle%20Day%203_lowres.mov?alt=media&token=390be512-4488-487d-9f24-815b3a0a7f92',
      }
    },
    "day-4-madidi-jungle": {
      title: 'Day 4 Madidi Jungle',
      type: 'video',
      origin: 'url',
      value: {
        filePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F037%20-%20Madidi%20Jungle%20Day%204.mp4?alt=media&token=eea3b855-4510-4d2d-8c5f-f8ce8f8212ee',
        lowResFilePath: 'https://firebasestorage.googleapis.com/v0/b/gem-russ-mega-trip.appspot.com/o/media%2F037%20-%20Madidi%20Jungle%20Day%204_lowres.mov?alt=media&token=df03b61f-b059-44a7-8082-f8e7977029e6',
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/temp/megaTripData.js